/* Kkumi shared "wait for WishlistKing" poller (JS side).
 *
 * The WishlistKing app (window.WishlistKing) loads async; the wishlist sections
 * each need to wait for it before reading/writing the list. ONE canonical poller
 * instead of four copies. Loaded head-defer so it's ready before the (deferred)
 * wishlist section scripts run.
 *
 * Usage:  var waitForWK = window.KKWaitForWK;
 *   waitForWK(function (WK) { ... }, onTimeout);   // onTimeout fires after ~20s
 */
(function () {
  if (window.KKWaitForWK) return;
  window.KKWaitForWK = function waitForWK(cb, onTimeout, t) {
    t = t || 0;
    if (window.WishlistKing) return cb(window.WishlistKing);
    if (t > 50) { if (onTimeout) onTimeout(); return; }
    setTimeout(function () { waitForWK(cb, onTimeout, t + 1); }, 400);
  };
})();
